import React, { useEffect, useState } from 'react';
import axiosInstance from "../../../../axiosInstance";
import { API_URL } from "../../../../config";
import { Helmet } from 'react-helmet-async';

function EmpPackagesPage() {
    const [payments, setPayments] = useState([]);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPayments = async () => {
            try {
                const res = await axiosInstance.get(`${API_URL}/admin/getAllPayments`);
                setPayments(res.data.data);
            } catch (err) {
                console.error("Failed to fetch payments", err);
            } finally {
                setLoading(false);
            }
        };

        fetchPayments();
    }, []);

    useEffect(() => {
        let dataTable = null;
        if (!loading && payments.length > 0) {
            const $ = window.$;
            // Destroy existing DataTable if it exists
            if ($.fn.DataTable.isDataTable('#payments_table')) {
                $('#payments_table').DataTable().destroy();
            }

            // Initialize new DataTable
            dataTable = $('#payments_table').DataTable({
                responsive: true,
                searching: true,
                ordering: true,
                paging: true,
                pageLength: 10,
                destroy: true,
                autoWidth: false,
                dom: 'Bfrtip',
                language: {
                    search: "Search:",
                    searchPlaceholder: "Search payments...",
                    emptyTable: "No payments available",
                    zeroRecords: "No matching payments found"
                },
                columnDefs: [
                    { 
                        targets: [5], // Payment Status column
                        createdCell: function (td, cellData, rowData, row, col) {
                            $(td).addClass(cellData === 'paid' ? 'text-success' : 'text-danger');
                        }
                    }
                ],
                order: [[0, 'desc']], // Sort by ID by default, newest first
                drawCallback: function() {
                    $('[data-bs-toggle="tooltip"]').tooltip();
                }
            });
        }

        // Cleanup function
        return () => {
            if (dataTable) {
                dataTable.destroy();
            }
        };
    }, [loading, payments]);

    return (
        <>
            <Helmet>
                <title>Payments | CV Diffusion</title>
                <meta name="description" content="Welcome to the home page of MyApp." />
            </Helmet>
            <div className="wt-admin-right-page-header clearfix">
                <h2>Payments</h2>
                <div className="breadcrumbs"><a href="#">Home</a><a href="#">Dashboard</a><span>Payments</span></div>
            </div>
            <div className="panel panel-default site-bg-white m-t30">
                <div className="panel-heading wt-panel-heading p-a20">
                    <h4 className="panel-tittle m-a0"><i className="fa fa-suitcase" />Payments</h4>
                </div>
                <div className="panel-body wt-panel-body">
                    <div className="p-a20 table-responsive">
                        <table id="payments_table" className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>User Name</th>
                                    <th>Package Name</th>
                                    <th>Transaction Id</th>
                                    <th>Amount</th>
                                    <th>Payment Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!loading && payments.map((payment, idx) => (
                                    <tr key={idx}>
                                        <td>{payment.id || 'N/A'}</td>
                                        <td>
                                            {payment.user ? 
                                                `${payment.user.first_name || ''} ${payment.user.last_name || ''}`.trim() || 'N/A'
                                                : 'N/A'
                                            }
                                        </td>
                                        <td>
                                            <span className="site-text-primary">
                                                {payment.transaction_data?.metadata?.planName || 'N/A'}
                                            </span>
                                        </td>
                                        <td>{payment.transaction_id || 'N/A'}</td>
                                        <td>{payment.total_amount ? `$${payment.total_amount}` : 'N/A'}</td>
                                        <td>
                                            <span className={`badge ${payment.payment_status === 'paid' ? 'bg-success' : 'bg-danger'}`}>
                                                {payment.payment_status || 'N/A'}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>Id</th>
                                    <th>User Name</th>
                                    <th>Package Name</th>
                                    <th>Transaction Id</th>
                                    <th>Amount</th>
                                    <th>Payment Status</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EmpPackagesPage;